export default __webpack_public_path__ + "static/media/trus7.4493755c.png";